module.exports = __webpack_public_path__ + "img/stock4.d8c6b123.png";